import { render, staticRenderFns } from "./AgeCheckFailed.vue?vue&type=template&id=3adb7c04&scoped=true&"
import script from "./AgeCheckFailed.vue?vue&type=script&lang=js&"
export * from "./AgeCheckFailed.vue?vue&type=script&lang=js&"
import style0 from "./AgeCheckFailed.vue?vue&type=style&index=0&id=3adb7c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb7c04",
  null
  
)

export default component.exports